import { Themed } from "@components/atoms/Themed"
import { cn } from "@utils/tw"
import { defineBlock, EditableText, useInlineEditableValue } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Text CTA",
  icon: "block-default",
  tags: ["#page"],
}

export default defineBlock("content/text-cta", (props) => {
  const [title] = useInlineEditableValue("author", "")
  const longTitle = title.length > 50

  return (
    <Themed theme={props.pageTheme || "green"} className="w-grid mx-auto my-10">
      <div className="flex flex-col gap-4 py-10 themed-bg themed-fg rounded-xl px-7 underline-links">
        <EditableText as="p" store="subtitle" className="type-label-s-caps" placeholder="Enter an optional subtitle" />
        <EditableText
          as="p"
          store="author"
          className={cn("type-title-m md:type-title-l !leading-[1.15]", longTitle && "type-body-xl md:type-title-l")}
          placeholder="Enter a title"
        />
      </div>
    </Themed>
  )
})
